import { createReducer, on } from '@ngrx/store';
import dayjs from 'dayjs';
import { PerformanceEvalDialogViewMode } from 'src/app/clinical/contracts/enums/performance-eval-dialog-view-mode.enum';
import { ContractGridItem } from 'src/app/clinical/contracts/grid/models/contract-grid-item.model';
import { PerformanceEval } from 'src/app/clinical/contracts/grid/models/performance-eval.model';
import * as performanceEvalActions from 'src/app/clinical/store/actions';

export interface PerformanceEvalState {
    contract: ContractGridItem;
    performanceEval: PerformanceEval;
    viewMode: PerformanceEvalDialogViewMode;
}

const initialState: PerformanceEvalState = {
    contract: null,
    performanceEval: null,
    viewMode: null
};

export const performanceEvalReducer = createReducer(
    initialState,
    on(performanceEvalActions.loadPerformanceEval, (state, action) => ({
        ...state,
        contract: action.payload.contract,
        viewMode: null
    })),

    on(performanceEvalActions.loadPerformanceEvalSuccess, (state, action) => ({
        ...state,
        performanceEval: action.payload.performanceEval,
        viewMode: action.payload.performanceEval.submissionDate
            ? PerformanceEvalDialogViewMode.view
            : PerformanceEvalDialogViewMode.edit
    })),

    on(performanceEvalActions.loadPerformanceEvalFail, (state, action) => ({
        ...state,
        performanceEval: {
            candidateFullName: action.payload.contract.candidateFullName,
            profession: action.payload.contract.professionName,
            assignmentDates: `${dayjs(action.payload.contract.startDate).format('MM/DD/YY')} - ${dayjs(
                action.payload.contract.endDate
            ).format('MM/DD/YY')}`,
            shiftTimes: action.payload.contract.shiftTimes,
            facilityName: action.payload.contract.facilityName,
            specialty: action.payload.contract.expertiseName
        } as PerformanceEval,
        viewMode: PerformanceEvalDialogViewMode.create
    })),

    on(performanceEvalActions.storePerformanceEvalSuccess, (state, action) => ({
        ...state,
        performanceEval: action.payload.performanceEval,
        viewMode: ((currentMode) => {
            switch (currentMode) {
                case PerformanceEvalDialogViewMode.create:
                    return PerformanceEvalDialogViewMode.edit;
                case PerformanceEvalDialogViewMode.edit:
                    return PerformanceEvalDialogViewMode.none;
                default:
                    return currentMode;
            }
        })(state.viewMode)
    }))
);
